<template>
  <DialogTemplate v-bind="props" :show-controls="true" align="center">
    <template #header>
      {{ title }}
    </template>
    <p v-if="label">{{ label }}</p>
    <div class="list">
      <DialogListItem
        v-for="(child, index) in items"
        :key="index"
        class="list-button"
        v-bind="child"
      />
    </div>
  </DialogTemplate>
</template>

<script lang="ts" setup>
interface ItemParam {
  label: string;
  click?: Function | Promise<void>;
  hasDiamond?: boolean;
}

interface Props {
  title: string;
  label?: string;
  iconHeader?: string | null;
  closeTimer?: number;
  closeClickOutside?: boolean;
  position?: 'center' | 'top-right';
  items: ItemParam[];
  cancel: boolean;
  confirm: boolean;
}

const props = defineProps({
  title: null,
  label: null,
  iconHeader: null,
  closeTimer: { default: -1 },
  closeClickOutside: { type: Boolean, default: true },
  position: { default: 'center' },
  items: null,
  cancel: { type: Boolean },
  confirm: { type: Boolean }
});

const emit = defineEmits(["cancel", "confirm"]);
</script>
<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;
  gap: var(--gap_n);
  width: 100%;
}
</style>
